import CardResetPin from 'components/card-reset-pin/card-reset-pin';
import CardUpdatePinFormConfirmation from 'components/card-update-pin-form-confirmation/card-update-pin-form-confirmation';
import EditCardStatus from 'features/cards/components/edit-single-card-status/edit-single-card-status';
import { SelectStatusFormValues } from 'features/cards/components/edit-single-card-status/SelectStatusForm';
import useCardEditStatusModal from 'features/cards/components/new-card-modal/card-edit-status-modal/useCardEditStatusModal';
import { useSelectCardDetails } from 'selectors/selectors';

interface CardActionProps {
  cardNumber: string;
  cardParent: string;
  closeForm: () => void;
  showUpdatePinForm?: boolean;
  showResetPinForm?: boolean;
  showUpdateStatusForm?: boolean;
}

export default function CardActions({
  cardNumber,
  cardParent,
  closeForm,
  showUpdatePinForm,
  showResetPinForm,
  showUpdateStatusForm,
}: CardActionProps) {
  const cardStatusEditModal = useCardEditStatusModal([cardNumber], closeForm);

  const onChangeCardStatusSubmitted = (values: SelectStatusFormValues) => {
    window.dataLayer.push({
      event: 'Card_Portal_Individual_Card_Detail_Status_Submit',
      button_click: true,
    });
    cardStatusEditModal.open(values);
  };

  const cardDetail = useSelectCardDetails();

  return (
    <div className='flex flex-col md:flex-row gap-m w-full'>
      <CardUpdatePinFormConfirmation
        confirmationMessage='This option will set a PIN on the selected card – would you like to proceed? Please ensure your drivers have been notified of the change.'
        cardNumbers={[cardNumber]}
        closeForm={closeForm}
        disabled={!showUpdatePinForm}
      />
      <CardResetPin
        cardsList={[cardNumber]}
        parentAccountNumber={cardParent}
        closeForm={closeForm}
        disabled={!showResetPinForm}
      />
      <EditCardStatus onSubmit={onChangeCardStatusSubmitted} disabled={!showUpdateStatusForm} />
    </div>
  );
}
